import { ArrangedMessage } from "../hooks/useChatRoom";
import * as React from "react";
import { NewMessagesSeparator } from "./NewMessagesSeparator";
import { Message as UserMessage } from "./Message";
import { Message as AdminMessage } from "../../pages/room-details/popup/chatbox/Messages";

interface IRowProps {
	message: ArrangedMessage;
	style: React.CSSProperties;
	userColorSettings?: any;
	users?: any;
}

const Message = (props) => {
	return props.userColorSettings && props.users ? <AdminMessage {...props} /> : <UserMessage {...props} />;
};

const MessageWrapper = ({ message, style, ...rest }: IRowProps, ref) => {
	return (
		<>
			{typeof message === "number" ? (
				<NewMessagesSeparator key={message} unreadMessageCount={message} />
			) : (
				<Message key={message._id} message={message} {...rest} />
			)}
		</>
	);
};

export const Row = React.memo(React.forwardRef<HTMLDivElement, IRowProps>(MessageWrapper), messagePropsAreEqual);

function messagePropsAreEqual(prevMsg, nextMsg) {
	return JSON.stringify(prevMsg) === JSON.stringify(nextMsg);
}
